import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M3 1.5v21a1.5 1.5 0 0 0 3 0v-21a1.5 1.5 0 0 0-3 0m5 13.35a1 1 0 0 0 .5.15 1 1 0 0 0 .5-.11l11.5-6a1 1 0 0 0 0-1.78L9 1.11A1 1 0 0 0 7.5 2v12a1 1 0 0 0 .5.85"
    }, null, -1)
  ]));
}
const interfaceFavoriteFlag = { render };
export {
  interfaceFavoriteFlag as default,
  render
};
//# sourceMappingURL=interface-favorite-flag.svg.js.map
